import { AUTH_TOKEN } from './serve/consts';
import { get } from './serve/localStorage';

export function getToken() {
  return get<string>(AUTH_TOKEN);
}
